$(document).ready(() => {

    $(document).on('click', '.js-paged-medienecho a.page-numbers', function(e){
        e.preventDefault();
        $(this).addClass('current').siblings('.page-numbers').removeClass('current');
        filterMedienecho($(this), 'load');
    });

    function filterMedienecho($el, $event){
        let $parent = $el.parents('.press-review');
        let numberposts = $parent.data('numberposts');
        let $categoryIds = $parent.data('category');
        let paged = 1;
        if ($parent.find('.page-numbers.current').length) {
            paged = $parent.find('.page-numbers.current').text();
        }
        let medienechoWrapp = $parent.find('.container');

        $('.loader').show();
        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'load_medienecho',
                numberposts: numberposts,
                category_ids: $categoryIds,
                paged: paged,
            },
            success(data) {
                medienechoWrapp.find('.block-press-review, .pagination').remove();
                medienechoWrapp.append(data.content);

                if ($event == 'load') {
                    $("html, body").animate({ scrollTop: 0 }, 600);
                }
            },
            complete: function(){
                $('.loader').hide();
            },
        });
    }

});
